module.exports = __webpack_public_path__ + "img/arrow-b.c8d8df4d.svg";